import { addProvider, metadataModuleProvider } from './metaData.js';
import calibratedPixelSpacingMetadataProvider from './utilities/calibratedPixelSpacingMetadataProvider.js';
import { registerCacheProviders } from './utilities/metadataProvider/cacheData.js';
import { registerUriModule } from './utilities/metadataProvider/uriModule.js';
import { registerDataLookup } from './utilities/metadataProvider/dataLookup.js';
import { registerInstanceFromListener } from './utilities/metadataProvider/instanceFromListener.js';
import { registerCombineFrameProvider } from './utilities/metadataProvider/combineFrameInstance.js';
import { clearTagModules, registerTagModules, } from './utilities/metadataProvider/tagModules.js';
import { registerImagePlaneCalibrated } from './utilities/metadataProvider/imagePlaneCalibrated.js';
import { registerCalibrationModule } from './utilities/metadataProvider/calibrationModule.js';
import { registerPixelDataUpdate } from './utilities/metadataProvider/pixelDataUpdate.js';
import { registerTransferSyntaxProvider } from './utilities/metadataProvider/transferSyntaxProvider.js';
import { registerEcgFromInstanceProvider } from './utilities/metadataProvider/ecgFromInstance.js';
import { registerCompressedFrameDataProvider } from './utilities/metadataProvider/compressedFrameData.js';
import { registerScalingFromInstanceProvider } from './utilities/metadataProvider/scalingFromInstance.js';
import { registerNaturalizedHandlers } from './utilities/metadataProvider/naturalizedHandlers.js';
import { registerImageIdProviders } from './utilities/metadataProvider/imageIdsProviders.js';
import { registerDisplaySetProviders } from './displayset/displaySetProvider.js';
const TYPED_PROVIDER_BRIDGE_PRIORITY = -1000;
export function registerDefaultProviders() {
    addProvider(metadataModuleProvider, TYPED_PROVIDER_BRIDGE_PRIORITY);
    addProvider(calibratedPixelSpacingMetadataProvider.get);
    clearTagModules();
    registerCacheProviders();
    registerNaturalizedHandlers();
    registerUriModule();
    registerImageIdProviders();
    registerDisplaySetProviders();
    registerDataLookup();
    registerInstanceFromListener();
    registerCombineFrameProvider();
    registerTagModules();
    registerEcgFromInstanceProvider();
    registerImagePlaneCalibrated();
    registerCalibrationModule();
    registerPixelDataUpdate();
    registerTransferSyntaxProvider();
    registerCompressedFrameDataProvider();
    registerScalingFromInstanceProvider();
}
